import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/monitor-speaker.vue
var o = {
	name: "DtIconMonitorSpeaker",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--monitor-speaker"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Monitor Speaker",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [
		r("path", {
			fill: "currentColor",
			"fill-rule": "evenodd",
			d: "M2.25 10a.5.5 0 0 1 .5-.5H4a.5.5 0 0 1 0 1H2.75a.5.5 0 0 1-.5-.5ZM8 4.5a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H8.5a.5.5 0 0 1-.5-.5Z",
			"clip-rule": "evenodd"
		}, null, -1),
		r("path", {
			fill: "currentColor",
			"fill-rule": "evenodd",
			d: "M7 2.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H7ZM5.5 3A1.5 1.5 0 0 1 7 1.5h3A1.5 1.5 0 0 1 11.5 3v6a1.5 1.5 0 0 1-1.5 1.5H7A1.5 1.5 0 0 1 5.5 9V3ZM.94 2.94A1.5 1.5 0 0 1 2 2.5h2a.5.5 0 0 1 0 1H2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h2a.5.5 0 0 1 0 1H2A1.5 1.5 0 0 1 .5 7V4c0-.398.158-.78.44-1.06Z",
			"clip-rule": "evenodd"
		}, null, -1),
		r("path", {
			fill: "currentColor",
			"fill-rule": "evenodd",
			d: "M7.5 7.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z",
			"clip-rule": "evenodd"
		}, null, -1)
	])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=monitor-speaker.js.map